import jwtDecode from "jwt-decode";
import { tokenKeyName } from "../config";
import useLocalStorage from "./useLocalStorage";

const useDecodeToken = () => {
  const localStorage = useLocalStorage({
    key: tokenKeyName,
    initialValue: null,
    options: {
      deserializer: (value) => jwtDecode(value),
    },
  });

  return localStorage;
};

export default useDecodeToken;
